var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('vue-apex-charts',{ref:"pieChart",attrs:{"type":"pie","height":"350","options":_vm.pieChart.chartOptions,"series":_vm.pieChart.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }